<!-- <form *ngIf="showHelp" name="form" (ngSubmit)="sendHelp($event,f , f.form.valid);" #f="ngForm" novalidate> -->
    <div *ngIf="showHelp" class="chat-box-sec">
        <form name="form" (ngSubmit)="sendHelp($event,f , f.form.valid);" #f="ngForm" novalidate>
            <div class="chat-hd" (click)="closeModal(f)">
                <h1 class="ttl pl-0">Leave us a message</h1>
                <a aria-label="Close" (click)="closeModal(f)" class="minimize-btn handsymbol">
                    <span class="icon">
                        <svg>
                            <path d="M0 0H30V5H0z"></path>
                        </svg>
                    </span>
                  </a>
            </div>
            <div class="chat-bdy">
                <div class="form-sec">
                    <div class="form-group">
                        <!-- <label for="fullName">Full Name</label> -->
                        <input type="text" class="form-control inputshadow" name="fullName"  [(ngModel)]="userObj.fullName" maxlength="60" (keydown.space)="userObj.fullName ? null : $event.preventDefault()"
                            #fullName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && fullName.invalid }"  placeholder="Full Name" required />
                        <div *ngIf="f.submitted && fullName.invalid" class="invalid-feedback">
                            <div *ngIf="fullName.errors.required" class="boxcolour alertMsg"><span class="fa fa-exclamation-circle mr-1"
                                    type="Icon"></span>Full Name is required</div>
                        </div>
                    </div>
    
                    <!-- <div class="form-group">
                        <input type="email" class="form-control inputshadow" name="email" [(ngModel)]="userObj.emailId"
                            #email="ngModel" [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" placeholder="Email Address" required email />
                        <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                            <div *ngIf="email.errors.required" class="boxcolour"><span _ngcontent-c2="" class="fa fa-exclamation-circle mr-1"
                                    type="Icon"></span>Email is required</div>
                            <div *ngIf="email.errors.email" class="boxcolour"><span _ngcontent-c2="" class="fa fa-exclamation-circle mr-1"
                                    type="Icon"></span>Please enter a valid email</div>
                        </div>
                    </div> -->
                    <div class="form-group">
                        <input type="text" class="form-control inputshadow" name="email" maxlength="60" [(ngModel)]="userObj.emailId" (keydown.space)="userObj.emailId ? null : $event.preventDefault()" #email="ngModel" [ngClass]="{ 'is-invalid': f.submitted && email.invalid }"
                          required email pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)\.*$"
                          placeholder="Email Address"/>
                        <div *ngIf="f.submitted && email.invalid" class="invalid-feedback">
                          <div class="boxcolour alertMsg" *ngIf="email.errors.required">
                                <span class="fa fa-exclamation-circle mr-1"
                                type="Icon"></span>Email is required</div>
                        </div>
                        <div [hidden]="email.valid || email.pristine || !email.errors.pattern" class="">
                          <div class="boxcolour alertMsg">
                                <span class="fa fa-exclamation-circle mr-1"
                                type="Icon"></span>Please enter a valid email</div>
                        </div>
                    </div>
                    <div class="form-group">
                        <!-- <label for="helpQues">How can we help you?</label> -->
                        <textarea type="text" class="form-control inputshadow removeResize" maxlength="150" name="helpQues" [(ngModel)]="userObj.helpQues" (keydown.space)="userObj.helpQues ? null : $event.preventDefault()"
                            #helpQues="ngModel" [ngClass]="{ 'is-invalid': f.submitted && helpQues.invalid }" placeholder="How Can We Help You?" required ></textarea>
                        <div *ngIf="f.submitted && helpQues.invalid" class="invalid-feedback">
                            <div *ngIf="helpQues.errors.required" class="boxcolour alertMsg"><span class="fa fa-exclamation-circle mr-1"
                                    type="Icon"></span>Please enter a value</div>
                        </div>
                    </div>
                    <!-- <div class="form-group float-label-control">
                    <label for="attachment">Attachments</label>
                    <input type='file' multiple>
                </div> -->
                    <div class="drop-container">
                        <h4 class="font15 attachlabel">Attachments <span class="text-muted ml-1" *ngIf="uploader.queue.length > 0">({{uploader.queue.length}})</span></h4>
                    </div>
                    <ul class="upldfile">
                        <li class="handsymbol" *ngFor="let fileobj of uploader.queue">
                            <i class="fa fa-file mr-2"></i>
                            <span>{{fileobj.file.name}}
                                <small class="text-muted clearfix float-left w-100">{{fileobj.file.unitSize}}</small>
                            </span>
                            <font class="upldclose" (click)="removeFile(fileobj)">x</font>
                        </li>
                        <li class="uploaderror" *ngIf="errorMsg">You have already reached the limit of 5 attachments</li>
                        <li class="uploaderror" *ngIf="invalidFileMsg">Please provide image or pdf files</li>
                    </ul>
                    <label class="upload-button text-center handsymbol">
                        <span> <img src="assets/images/attachment.svg" width="16px" class="mr-2">
                            <font class="font13 addupfiles">Add up to 5 files</font></span>
                        <!-- <input type="file" name="userPhoto" ngFileSelect [options]="options" (uploadOutput)="onUploadOutput($event)" accept=".jpg,.pdf,.jpeg,.png,.svg,.bmp" multiple > -->
                        <input type="file" name="photo" ng2FileSelect [uploader]="uploader" accept=".jpg,.pdf,.jpeg,.png,.svg,.bmp"
                            multiple>
                    </label>
                </div>
            </div>
            <div class="chat-ftr">
                <div class="text-center">
                    <div class="form-group float-label-control mb-0">
                        <button type="button" class="btn-wht handsymbol" (click)="closeModal(f)">CANCEL</button> &nbsp;
                        <button type="button" class="btn-gry handsymbol" type="submit">SEND</button>
                    </div>
                </div>
            </div>
        </form>
    </div>
    
    <div class="modal fade" data-backdrop="static" data-keyboard="false" id="helpModel" tabindex="-1" role="dialog"
        aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog" role="document">
          <div class="modal-content zind1 brdRadius">
            <div class="modal-body pt-0 pb-2">
              <button type="button" class="close videoclose outline" data-dismiss="modal" aria-label="Close" (click)="closeResetModal()">
                <div class="float-right mr-1 mt-0" >
                  <img src="assets/images/editchart-close.svg" width="20">
                </div>
              </button>
              <div class="service-modal">
                <div class="bdy-sec">
                  <div>
                    <p class="mt-4 pt-2 sb-ttl resettxt webview text-center helpAlert">Thank you! Your message has been sent.<br>A member of our team will be in touch soon!
                    <!-- <font class="text-center semi-bold">{{enteredEmail}}</font></p> -->
                  </p>
                  <p class="mt-4 pt-2 sb-ttl resettxt mobileview text-center helpAlert">Thank you! Your message has been sent. A member of our team will be in touch soon!</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    
      <!-- Modal -->
    <div class="backdrop" [ngStyle]="{'display':display}"></div>
    <div class="modal" tabindex="-1" role="dialog" [ngStyle]="{'display':display}">
      <div class="modal-dialog" role="document">
        <div class="modal-content m-auto blockbg boxclr text-center">
          <div class="modal-body">
            <!-- <div class="mt-5"> -->
            <div class="">
              <img src="assets/images/loading.gif" />
              <p class="text-center tipmes font15">Please wait for a few seconds...
              </p>
            </div>
            <!-- </div> -->
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal !-->